/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { MyIcon } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import classes from '../ServiceWrapper.module.scss';
import { IImportFileState } from './ImportFileData';

/**
 * @method showImportNotification
 * @description Displays the import notification in services
 * @param importState import state
 * @param closeUploadNotification  callback function to close notification
 * @returns notification ui
 */
const showImportNotification = (importState: IImportFileState, closeUploadNotification: () => void) => {
  const { t: translate } = useTranslation();
  return (
    importState.uploadFileName && importState.fileNotificationStatus && (
      importState.fileUploadStatus ? (
        <div className={classes['filename-populated-wrapper']}>
          <div className={classes['filename-populated-content']}>{translate('service_wrapper_component.msg_upload_swagger_success')}
            <span className={classes['filename-populated-close']} onClick={closeUploadNotification}>{translate('service_wrapper_component.lbl_close')}</span>
          </div>
          <div className={classes['filename-populated']}>{importState.uploadFileName}<span><MyIcon name="checkCircleFillIcon" className={classes['fill-icon']} /></span></div>
        </div>
    ) : (
      <div className={classes['filename-populated-wrapper']}>
        <div className={classes['filename-populated-content']}>{translate('service_wrapper_component.msg_upload_swagger_error')}
          <span data-testid="succes-upload-status" className={classes['filename-populated-close']} onClick={closeUploadNotification}>{translate('service_wrapper_component.lbl_close')}</span>
        </div>
        <div className={classes['filename-populated-error']}>{importState.uploadFileName}</div>
        <p className={classes['upload-error-text']}>{translate('service_wrapper_component.msg_upload_unsupported_file')}</p>
      </div>
      )
    )
  );
};

export default showImportNotification;
